(function () {
  function normalize(value) {
    return value
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .trim();
  }

  function parseI18n(root) {
    try {
      return JSON.parse(root.querySelector('[data-calorie-i18n]').textContent);
    } catch (error) {
      return {};
    }
  }

  function tReplace(template, vars) {
    var output = template || '';
    Object.keys(vars || {}).forEach(function (key) {
      output = output.split('{{ ' + key + ' }}').join(vars[key]);
    });
    return output;
  }

  function initCalorieCalculator(root) {
    var db = window.CalorieFoodDatabase || [];
    if (!db.length) return;

    var i18n = parseI18n(root);
    var foods = [];
    var activeIndex = -1;

    var input = root.querySelector('[data-calorie-input]');
    var portionInput = root.querySelector('[data-calorie-portion]');
    var addButton = root.querySelector('[data-calorie-add]');
    var drawer = root.closest('health-calc-drawer');
    var clearButton =
      (drawer && drawer.querySelector('[data-calorie-clear]')) ||
      root.querySelector('[data-calorie-clear]');
    var listEmptyEl = root.querySelector('[data-calorie-list-empty]');
    var errorEl = root.querySelector('[data-calorie-error]');
    var listEl = root.querySelector('[data-calorie-list]');
    var totalEl = root.querySelector('[data-calorie-total]');
    var autocompleteEl = root.querySelector('[data-calorie-autocomplete]');

    function search(query) {
      if (!query) return [];
      var normalizedQuery = normalize(query);
      var starts = [];
      var includes = [];

      db.forEach(function (item) {
        var name = normalize(item.n);
        if (name.startsWith(normalizedQuery)) starts.unshift(item);
        else if (name.includes(normalizedQuery)) includes.push(item);
      });

      return starts.concat(includes).slice(0, 8);
    }

    function findExact(query) {
      var normalizedQuery = normalize(query);
      for (var i = 0; i < db.length; i++) {
        if (normalize(db[i].n) === normalizedQuery) return db[i];
      }
      for (var j = 0; j < db.length; j++) {
        if (normalize(db[j].n).startsWith(normalizedQuery)) return db[j];
      }
      for (var k = 0; k < db.length; k++) {
        var name = normalize(db[k].n);
        if (name.includes(normalizedQuery) || normalizedQuery.includes(name)) return db[k];
      }
      return null;
    }

    function hideError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function showError(message) {
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function hideAutocomplete() {
      autocompleteEl.hidden = true;
      autocompleteEl.classList.remove('is-visible');
      autocompleteEl.innerHTML = '';
      activeIndex = -1;
    }

    function showAutocomplete(results) {
      autocompleteEl.innerHTML = results
        .map(function (item) {
          var label = (i18n.kcal_per_100g || '{{ value }} kcal/100g').replace('{{ value }}', item.k);
          return (
            '<button type="button" class="health-calc__ac-item" data-ac-name="' +
            item.n.replace(/"/g, '&quot;') +
            '"><span>' +
            item.n +
            '</span><span class="text-subdued text-xs">' +
            label +
            '</span></button>'
          );
        })
        .join('');
      autocompleteEl.hidden = false;
      autocompleteEl.classList.add('is-visible');
    }

    function highlightAutocomplete() {
      var items = autocompleteEl.querySelectorAll('.health-calc__ac-item');
      items.forEach(function (item, index) {
        item.classList.toggle('is-active', index === activeIndex);
      });
      if (activeIndex >= 0 && items[activeIndex]) {
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    function addFood() {
      var foodName = input.value.trim();
      var portion = parseInt(portionInput.value, 10) || i18n.default_portion || 100;
      hideError();
      hideAutocomplete();

      if (!foodName) {
        showError(i18n.error_empty || 'Please enter a food name.');
        return;
      }

      var record = findExact(foodName);
      if (!record) {
        showError(tReplace(i18n.error_not_found || 'Food not found.', { food: foodName }));
        return;
      }

      var ratio = portion / 100;
      foods.push({
        id: Date.now() + Math.random(),
        name: record.n,
        portion: portion,
        kcal: Math.round(record.k * ratio),
        p: parseFloat((record.p * ratio).toFixed(1)),
        c: parseFloat((record.c * ratio).toFixed(1)),
        f: parseFloat((record.f * ratio).toFixed(1)),
      });

      input.value = '';
      portionInput.value = i18n.default_portion || 100;
      input.focus();
      render();
    }

    function removeFood(id) {
      foods = foods.filter(function (food) {
        return food.id !== id;
      });
      render();
    }

    function render() {
      if (!foods.length) {
        if (listEmptyEl) listEmptyEl.hidden = false;
        if (listEl) listEl.hidden = true;
        listEl.innerHTML = '';
        totalEl.hidden = true;
        totalEl.classList.remove('is-visible');
        if (clearButton) clearButton.hidden = true;
        return;
      }

      if (listEmptyEl) listEmptyEl.hidden = true;
      if (listEl) listEl.hidden = false;
      if (clearButton) clearButton.hidden = false;

      listEl.innerHTML = foods
        .map(function (food) {
          var macros =
            (i18n.macro_protein_short || 'P') +
            ':' +
            food.p +
            'g · ' +
            (i18n.macro_carbs_short || 'K') +
            ':' +
            food.c +
            'g · ' +
            (i18n.macro_fat_short || 'Y') +
            ':' +
            food.f +
            'g';

          return (
            '<div class="health-calc__food-item">' +
            '<div class="health-calc__food-item-info">' +
            '<p class="health-calc__food-item-name">' +
            food.name +
            ' <span class="health-calc__food-item-portion">' +
            food.portion +
            'g</span></p>' +
            '<p class="health-calc__food-item-macros">' +
            macros +
            '</p></div>' +
            '<span class="health-calc__food-kcal">' +
            food.kcal +
            ' <span class="health-calc__food-kcal-unit">' +
            (i18n.kcal || 'kcal') +
            '</span></span>' +
            '<button type="button" class="health-calc__food-remove" data-remove-food="' +
            food.id +
            '" aria-label="Remove">✕</button></div>'
          );
        })
        .join('');

      var totals = foods.reduce(
        function (acc, food) {
          return {
            kcal: acc.kcal + food.kcal,
            p: parseFloat((acc.p + food.p).toFixed(1)),
            c: parseFloat((acc.c + food.c).toFixed(1)),
            f: parseFloat((acc.f + food.f).toFixed(1)),
          };
        },
        { kcal: 0, p: 0, c: 0, f: 0 }
      );

      root.querySelector('[data-calorie-total-kcal]').textContent = totals.kcal;
      root.querySelector('[data-calorie-total-p]').textContent = totals.p + 'g';
      root.querySelector('[data-calorie-total-c]').textContent = totals.c + 'g';
      root.querySelector('[data-calorie-total-f]').textContent = totals.f + 'g';
      totalEl.hidden = false;
      totalEl.classList.add('is-visible');
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      activeIndex = -1;
      if (!query) {
        hideAutocomplete();
        return;
      }
      var results = search(query);
      if (!results.length) hideAutocomplete();
      else showAutocomplete(results);
    });

    input.addEventListener('keydown', function (event) {
      var items = autocompleteEl.querySelectorAll('.health-calc__ac-item');
      if (!items.length) {
        if (event.key === 'Enter') {
          event.preventDefault();
          addFood();
        }
        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        highlightAutocomplete();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = Math.max(activeIndex - 1, -1);
        highlightAutocomplete();
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (activeIndex >= 0) {
          applyAutocompleteSelection(items[activeIndex].dataset.acName);
        } else {
          addFood();
        }
      } else if (event.key === 'Escape') {
        hideAutocomplete();
      }
    });

    input.addEventListener('blur', function () {
      setTimeout(hideAutocomplete, 150);
    });

    function applyAutocompleteSelection(name) {
      input.value = name;
      hideAutocomplete();
      portionInput.focus();
      portionInput.select();
    }

    autocompleteEl.addEventListener('mousedown', function (event) {
      var item = event.target.closest('[data-ac-name]');
      if (!item) return;
      event.preventDefault();
      applyAutocompleteSelection(item.dataset.acName);
    });

    addButton.addEventListener('click', addFood);
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        foods = [];
        render();
      });
    }

    listEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-remove-food]');
      if (!button) return;
      removeFood(Number(button.dataset.removeFood));
    });

    root.querySelectorAll('[data-kp-quick]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.dataset.kpQuick;
        portionInput.value = chip.dataset.kpGrams || i18n.default_portion || 100;
        addFood();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-calorie-calculator]').forEach(initCalorieCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
